module.exports = __webpack_public_path__ + "c1da4e2130713634e25131eec9383e14.png";